"use client";
import { useEffect, useState } from "react";
import PlaylistSlider from "@/components/PlaylistSlider";
import SectionWithPlayAll from "@/components/SectionWithPlayAll";
import styles from './SearchResults.module.css';
type SearchItem = {
  id?: number;
  title: string;
  slug?: string;
  type: "song" | "playlist" | "work" | "composer";
  imageUrl?: string | null;
  audioUrl?: string | null; // для song
  duration?: string | null; // для song
  playlisttrack?: {
    song: {
      id: number;
      title: string;
      composer?: string;
      slug?: string;
      imageUrl?: string | null;
      audioUrl: string;
      duration?: string;
    };
  }[]; // для work и playlist
};


export default function SearchResults({ query }: { query: string }) {
  const [results, setResults] = useState<SearchItem[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!query) return;

    setLoading(true);
    fetch(`/api/search?q=${encodeURIComponent(query)}`)
      .then((res) => res.json())
      .then((data) => setResults(data.results || []))
      .catch(() => setResults([]))
      .finally(() => setLoading(false));
  }, [query]);

  if (!query) return null;
  // 👇 вспомогательная функция
  const normalizeItems = (items: SearchItem[]) =>
    items.map(i => ({ ...i, _type: i.type }));
  // 🎼 Songs section includes songs and works only
 const songsSection = normalizeItems(
  results.filter(r => r.type === "song" || r.type === "work")
  );

  // 📁 Playlists section includes playlists only
const playlists = normalizeItems(
  results.filter(r => r.type === "playlist")
);


  return (
    <div className={styles.container}>
      {loading && <p>Loading...</p>}
      <h1 className={styles.pageTitle}>
        Search results: <em>{query}</em>
      </h1>
      {playlists.length > 0 && (
        <SectionWithPlayAll title="Playlists" playlists={playlists}>
          <PlaylistSlider items={playlists} type="playlist" visibleCount={5} />
        </SectionWithPlayAll>
      )}
      
      {songsSection.length > 0 && (
        <SectionWithPlayAll title="Songs" songs={songsSection}>
          <PlaylistSlider items={songsSection} visibleCount={5} />
        </SectionWithPlayAll>
      )}

      

      {!loading && songsSection.length === 0 && playlists.length === 0 && (
        <p>No results found</p>
      )}
    </div>
  );
}
